<template>
  <v-modal
    @hide-modal="$emit('hide-modal')"
  >
    <template v-slot:title>
      <h4>{{ $t('phrase.merge_item') }}</h4>
    </template>
    <template v-slot:body>
      <div>
        <div class="row">
          <div class="col-md-6">
            <div v-if="itemFirst">
              <v-item-detail
                :item="itemFirst"
              />
            </div>
          </div>
          <div
            class="col-md-6"
            v-if="itemSecond"
          >
            <v-item-detail
              :item="itemSecond"
            />
          </div>
          <div
            class="col-md-6"
            v-else
          >
            <h4 class="mr-2">{{ $t('phrase.merge_with') }}</h4>
            <div class="mb-2">
              <form
                class="d-flex w-100"
                method="post"
                @submit.prevent="filterObjects(searchQuery)"
              >
                <v-text-input
                  id="item-list-search"
                  v-model="searchQuery"
                  placeholder="word.search"

                />
                <div>
                  <v-button
                    icon="search"
                    style-type="secondary"
                    type="submit"
                  />
                </div>
              </form>
            </div>
            <table class="table table-sm">
              <tr
                v-for="item in objectList"
                :key="item.id"
              >
                <td>
                  {{ item.title }}
                </td>
                <td>
                  <v-button
                    :disabled="item.id === itemId || loading"
                    text="word.select"
                    style-type="primary"
                    size="xs"
                    @click="fetchItemSecond(item.id)"
                  />
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div v-if="itemSecond">
        <div class="row">
          <div class="col-md-6"></div>
          <div class="col-md-6">
            <v-button
              text="phrase.choose_other_item"
              icon="chevron-left"
              style-type="link"
              @click="itemSecond = null"
            />
          </div>
        </div>

        <hr />

        <div class="row">
          <div class="col-md-6">
            <v-button
              text="phrase.save_as_this_item"
              :icon="itemFirstPrimary ? 'check' : 'times'"
              :style-type="itemFirstPrimary ? 'success' : 'light'"
              @click="itemFirstPrimary = true"
              :block="true"
              size="sm"
            />
          </div>
          <div class="col-md-6">
            <v-button
              text="phrase.save_as_this_item"
              :icon="itemFirstPrimary ? 'times' : 'check'"
              :style-type="itemFirstPrimary ? 'light' : 'success'"
              @click="itemFirstPrimary = false"
              :block="true"
              size="sm"
            />
          </div>
        </div>
        <hr />
        <div class="d-flex justify-content-end">
          <v-button
            text="word.merge"
            style-type="primary"
            @click="submit"
            :loading="loading"
          />
        </div>
      </div>
    </template>
  </v-modal>
</template>

<script>
import { fetchItem, mergeItems } from '@/admin/api';
import { GenericListMixin } from '@/common/utils/mixins';
import Button from '@/common/components/Button.vue';
import Modal from '@/common/components/Modal.vue';
import TextInput from '@/common/components/inputs/TextInput.vue';
import ItemDetail from '@/admin/components/ItemDetail.vue';

export default {
  name: 'MergeItemsModal',
  components: {
    'v-button': Button,
    'v-modal': Modal,
    'v-text-input': TextInput,
    'v-item-detail': ItemDetail,
  },
  props: {
    itemId: {
      type: Number,
      required: true,
    },
    renderType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      itemFirst: null,
      itemSecond: null,
      itemFirstPrimary: true,
      apiPath: 'admin/items/',
      loading: false,
    };
  },
  mixins: [
    GenericListMixin,
  ],
  methods: {
    getParams() {
      return {
        render_type: this.renderType,
      };
    },
    async submit() {
      let response;
      if (this.itemFirstPrimary) {
        response = await mergeItems(this.itemSecond.id, this.itemFirst.id);
      } else {
        response = await mergeItems(this.itemFirst.id, this.itemSecond.id);
      }
      if (response.status === 200) {
        this.$emit('merged');
      } else {
        alert(
          `Something went wrong in merging the items with status code ${response.status}.`
          + 'Check the Console for more details.',
        );
        console.error(response);
      }
    },
    async fetchItemFirst() {
      const response = await fetchItem(this.itemId);
      if (response.data) {
        this.itemFirst = response.data;
      } else {
        alert('Something went wrong in loading the item.');
      }
    },
    async fetchItemSecond(itemId) {
      this.loading = true;
      const response = await fetchItem(itemId);
      if (response.data) {
        this.itemSecond = response.data;
      } else {
        alert('Something went wrong in loading the item.');
      }
      this.loading = false;
    },
  },
  created() {
    this.fetchItemFirst();
  },
};
</script>
